export const PDF_ZOOM_SCALE = {
  MIN: 0.6,
  MAX: 3.0,
};

export const IMPROVED_HEADING_OFFSET = {
  X: -6,
  Y: -4,
  WIDTH: 12,
  HEIGHT: 10,
};
